<template>
  <div class="aiChat yazdirma">
    <div class="aiChatBody" v-if="Durum">
      <div class="aiChatHead">
        <a v-if="!ChatDetayText" @click="Durum=false" class="aiKapat"><i class="el-icon-circle-close"></i> </a>
        <a v-if="ChatDetayText" @click="aiGeri" class="aiKapatGeri"><i class="el-icon-caret-left"></i>
        </a>
        <h1>

          <svg v-if="!ChatDetayText" viewBox="-21 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path class="st0"
                  fill="#FFFFFF"
                  d="M256,0c141.2,0,256,114.8,256,256v240c0,8.8-7.2,16-16,16H256C114.8,512,0,397.2,0,256S114.8,0,256,0z"/>
            <path fill="#4185F4"
                  d="M240,320h128c8.8,0,16-7.2,16-16s-7.2-16-16-16H240c-8.8,0-16,7.2-16,16S231.2,320,240,320z"/>
            <path fill="#4185F4"
                  d="M144,224h224c8.8,0,16-7.2,16-16s-7.2-16-16-16H144c-8.8,0-16,7.2-16,16S135.2,224,144,224z"/>
          </svg>
          <b v-if="!ChatDetayText">Chat</b>
          <b v-if="ChatDetayText">{{ ChatDetayText.Kullanici }}</b>
        </h1>
        <span v-if="!ChatDetayText">Şirket içi veya diğer şirketler ile online yazışabilirsiniz.</span>
        <span v-if="ChatDetayText">{{ ChatDetayText.Sirket }} <b v-if="ChatDetayText.sg"> <i class="el-icon-time"></i> {{
            ChatDetayText.sg
          }}</b></span>
      </div>
      <ChatListe :Yapifen="Yapifen" v-if="Durum && !ChatDetayData" @ChatDetay="fChatDetay($event)"></ChatListe>
      <ChatDetay v-if="Durum && ChatDetayData" :Data="ChatDetayData" @Kapat="ChatDetayData=null"></ChatDetay>
    </div>
    <a @click="Durum=true" class="ChatBalon">
      <div class="ChatBalonBildirim" v-if="Yeni>0">{{ Yeni }}</div>
      CHAT
    </a>
  </div>
</template>

<script>
import ChatDetay from "./ChatDetay";
import ChatListe from "./ChatListe";

export default {
  components: {ChatListe, ChatDetay},
  data() {
    return {
      Yeni: 0,
      Yapifen: 0,
      Durum: false,
      Start: true,
      ChatDetayData: null,
      ChatDetayText: null
    }
  },
  methods: {
    aiGeri() {
      this.ChatDetayData = null
      this.ChatDetayText = null
    },
    fChatDetay(e) {
      this.ChatDetayData = e
      this.ChatDetayText = e
      if (e === 'Yapifen') {
        this.ChatDetayText = {
          'Sirket': 'Muhasebe > Mesken Borçlandır menüsünde sağ üst kısımda Ekspres Borçlandırma seçeneğinden seçerek yapabilirsiniz.',
          'Kullanici': 'Yapıfen',
        }
      }
    },
    Sor() {
      this.$store.dispatch("Get", {path: '_chat/ping'})
        .then(response => {
          if (response.Durum == "OK") {
            if (this.Yeni < response.Say) {
              new Audio('https://cdn.mudu.pro/Design/sound/msn.mp3').play();
              // console.log("Çal " + this.Yeni + " " + response.Say)
            }
            this.Yeni = response.Say
            this.Yapifen = response.Yapifen
            setTimeout(() => {
              if (this.Start) this.Sor();
            }, 5000);
          } else {
            this.Start = false
          }
        })
    }
  },
  created() {
    this.Sor()
  },
  destroyed() {
    this.Start = false
  }
}
</script>

<style scoped>
@import '../../../../dist/assets/css/chat.css';
</style>



// WEBPACK FOOTER //
// src/components/Pack/Chat/ChatWidget.vue